
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M8 10.997a1.5 1.5 0 11-.001 3 1.5 1.5 0 01.001-3zm0-4.5a1.5 1.5 0 11-.001 3 1.5 1.5 0 01.001-3zm0-4.5a1.5 1.5 0 11-.001 3 1.5 1.5 0 01.001-3z"}})])
          )
        }
      }
    